import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useIsTouch } from '../../hooks/useMediaQuery';

export const SortableRow = ({ id, children, disabled }) => {
    // Touch: keep touch-action auto (below) so quick swipes scroll
    // Drag: start via a long-press on the handle (see TouchSensor in useDnd)
    const isTouch = useIsTouch();

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: id,
        data: {
            type: 'Row',
            rowId: id,
        },
        disabled: disabled
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        position: 'relative',
        zIndex: isDragging ? 999 : 'auto',
        opacity: isDragging ? 0.8 : 1,
        boxShadow: isDragging ? '0px 5px 15px rgba(0,0,0,0.2)' : 'none',
        scale: isDragging ? '1.02' : '1',
        touchAction: isTouch ? 'auto' : 'none',
        cursor: isDragging ? 'grabbing' : 'auto',
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            // Touch: the whole row is the drag activator (long-press)
            // Desktop: listeners go to the handle as before
            {...(isTouch ? listeners : {})}
        >
            {typeof children === 'function'
                ? children({ listeners: isTouch ? {} : listeners, attributes })
                : children
            }
        </div>
    );
};
